import { useEffect } from 'react'

import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import { FormFieldRow } from '@/components/forms/BookTradeForm/FormFieldRow'
import { CounterpartyIdField } from '@/pages/instruments/new-instrument/form-fields/CounterpartyIdField'
import { CurrencyIdInput } from '@/pages/instruments/new-instrument/form-fields/CurrencyIdInput'
import { DescriptionFormField } from '@/pages/instruments/new-instrument/form-fields/DescriptionFormField'
import { FundIdField } from '@/pages/instruments/new-instrument/form-fields/FundIdField'
import { MaturityDateField } from '@/pages/instruments/new-instrument/form-fields/MaturityDateField'
import { QuoteFactorFormField } from '@/pages/instruments/new-instrument/form-fields/QuoteFactorFormField'
import { StructureNameField } from '@/pages/instruments/new-instrument/form-fields/StructureNameField'
import { TopLevelBucketFormField } from '@/pages/instruments/new-instrument/form-fields/TopLevelBucketFormField'
import { UnitMultiplierFormField } from '@/pages/instruments/new-instrument/form-fields/UnitMultiplierFormField'
import { FxFwdSchemaType } from '@/pages/instruments/new-instrument/schemas/fxfwd.schema'

export interface FxFwdFieldsProps {}

export const FxFwdFields: React.FC<FxFwdFieldsProps> = ({}) => {
  const { control, trigger, setValue } = useFormContext<FxFwdSchemaType>()

  useEffect(() => {
    trigger()
  }, [])

  return (
    <div className={'@container flex flex-col gap-6'}>
      <StructureNameField placeholder={'FXFWD_BONDISIN_ARF'} />
      <FormFieldRow>
        <FormField
          name="currency_from_id"
          control={control}
          render={({ field: { value } }) => {
            return (
              <FormItem>
                <div className="flex items-center gap-2">
                  <FormLabel>Currency From (Fund)</FormLabel>
                  <FormError />
                </div>
                <CurrencyIdInput
                  value={value?.toString()}
                  setValue={(value) =>
                    setValue('currency_from_id', parseInt(value), { shouldValidate: true })
                  }
                  className={'flex flex-1 min-w-auto!'}
                  placeholder={'Select a from currency'}
                />
              </FormItem>
            )
          }}
        />

        <FormField
          name="currency_quote_id"
          control={control}
          render={({ field: { value } }) => {
            return (
              <FormItem>
                <div className="flex items-center gap-2">
                  <FormLabel>Currency Quote</FormLabel>
                  <FormError />
                </div>
                <CurrencyIdInput
                  value={value?.toString()}
                  setValue={(value) =>
                    setValue('currency_quote_id', parseInt(value), { shouldValidate: true })
                  }
                  className={'flex flex-1 min-w-auto!'}
                  placeholder={'Select a quote currency'}
                />
              </FormItem>
            )
          }}
        />

        <TopLevelBucketFormField />
      </FormFieldRow>

      <FormFieldRow>
        <MaturityDateField />
        <FundIdField />
        <CounterpartyIdField />
      </FormFieldRow>

      <FormFieldRow>
        <UnitMultiplierFormField />
        <QuoteFactorFormField />
      </FormFieldRow>

      <DescriptionFormField />
    </div>
  )
}
